module.exports = __webpack_public_path__ + "img/18.b1e157ca.jpg";